import React from 'react';
import HeaderOne from '../common/header/HeaderOne';
import FooterOne from '../common/footer/FooterOne';
import Breadcrumb from '../common/breadcrumb/Breadcrumb';
import { CurrentSeason } from '@/components/seasonal';
import { SeasonalCalendar } from '@/components/seasonal';
import { ProduceByMonth } from '@/components/seasonal';
import { SeasonalHighlights } from '@/components/seasonal';
import { SeasonalProduceWidget, RecipeSuggestionsWidget, NutritionInfoWidget } from '@/components/widgets';
import { seasonalProduceAgent } from '@/services/agents';

const Seasonal: React.FC = () => {
  return (
    <>
      <HeaderOne />
      <Breadcrumb
        title="Seasonal Guide"
        currentPage="Seasonal"
        img="/assets/images/backgrounds/breadcrumb-bg.jpg"
      />

      {/* Current Season Hero */}
      <CurrentSeason />

      {/* Seasonal Highlights */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-bark mb-6">
            What's Fresh Now
          </h2>
          <SeasonalHighlights />
        </div>
      </section>

      {/* Seasonal Calendar */}
      <section className="py-12 bg-cream">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-bark mb-6">
            Year-Round Availability
          </h2>
          <SeasonalCalendar />
        </div>
      </section>

      {/* Produce by Month */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-bark mb-6">
            Monthly Produce Guide
          </h2>
          <ProduceByMonth />
        </div>
      </section>

      {/* AI-Powered Widgets Section */}
      <section className="py-12 bg-cream">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-bark mb-4">
              Smart Seasonal Insights
            </h2>
            <p className="text-gray-600">
              AI-powered recommendations for seasonal eating
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Enhanced Seasonal Widget */}
            <SeasonalProduceWidget showPeakOnly={false} maxItems={8} />

            {/* Seasonal Recipe Suggestions */}
            <RecipeSuggestionsWidget
              ingredients={seasonalProduceAgent.getCurrentSeasonProduce().map(p => p.name).slice(0, 5)}
              maxRecipes={3}
            />

            {/* Nutrition Info for Peak Produce */}
            {seasonalProduceAgent.getCurrentPeakProduce()[0] && (
              <NutritionInfoWidget
                produceName={seasonalProduceAgent.getCurrentPeakProduce()[0].name}
                showHealthScore={true}
              />
            )}
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default Seasonal;
